/**
 * Essentials 7-day expanded access: signup day + 6 days, end of day (23:59:59.999).
 * Fail closed when signup date is unknown.
 */

export function computeExpandedAccessEndsAt(customerCreatedAt) {
	if (!customerCreatedAt) return null;
	const start = new Date(customerCreatedAt);
	if (Number.isNaN(start.getTime())) return null;
	const end = new Date(start);
	end.setDate(end.getDate() + 6);
	end.setHours(23, 59, 59, 999);
	return end;
}

export function isExpandedAccessExpiredFromDate(customerCreatedAt, now = Date.now()) {
	const end = computeExpandedAccessEndsAt(customerCreatedAt);
	if (!end) return true;
	return now > end.getTime();
}

/**
 * Prefer API subscription fields; fall back to user.createdAt only (never today).
 */
export function resolveExpandedAccessState(subscription, userCreatedAt) {
	if (subscription?.expandedAccessExpired === true) {
		return {
			expired: true,
			endsAt: subscription.expandedAccessEndsAt
				? new Date(subscription.expandedAccessEndsAt)
				: computeExpandedAccessEndsAt(userCreatedAt)
		};
	}
	if (subscription?.expandedAccessExpired === false) {
		return {
			expired: false,
			endsAt: subscription.expandedAccessEndsAt
				? new Date(subscription.expandedAccessEndsAt)
				: computeExpandedAccessEndsAt(userCreatedAt)
		};
	}
	if (userCreatedAt) {
		const endsAt = computeExpandedAccessEndsAt(userCreatedAt);
		return {
			expired: isExpandedAccessExpiredFromDate(userCreatedAt),
			endsAt
		};
	}
	return { expired: true, endsAt: null };
}
